// filters recipe – mappa taxonomy → [values]
let selectedFilters = {};
let searchQuery = '';
let currentResultsPage = 1;
const RECIPES_FILTER_API = '/wp-json/mutti/v1/recipes-filter';

// --- Fetch con delay (debounced) ---
let fetchTimer = null;

function buildRecipesApiUrl(page) {
  const url = new URL(RECIPES_FILTER_API, window.location.origin);
  url.searchParams.set('page', String(page || 1));

  if (searchQuery) {
    url.searchParams.set('search', searchQuery);
  }

  Object.keys(selectedFilters).forEach(function (taxonomy) {
    const values = selectedFilters[taxonomy];

    if (values && values.length > 0) {
      url.searchParams.set(taxonomy, values.join(','));
    }
  });

  return url;
}

function updateResultsUI(data, append) {
  const grid = document.querySelector('.filters-results-grid');
  const counter = document.querySelector('.result-counter-number');
  const loadMoreWrap = document.querySelector('.filters-results-load-more');
  const loadMoreBtn = loadMoreWrap ? loadMoreWrap.querySelector('.load-more-button') : null;

  if (counter && typeof data.total !== 'undefined') {
    counter.textContent = data.total;
  }

  if (grid) {
    if (append && data.html) {
      grid.insertAdjacentHTML('beforeend', data.html);
    } else {
      grid.innerHTML = data.html || '';
    }
  }

  currentResultsPage = data.page || 1;

  if (loadMoreWrap) {
    loadMoreWrap.dataset.page = String(currentResultsPage);

    if (data.has_more) {
      loadMoreWrap.style.display = '';
    } else {
      loadMoreWrap.style.display = 'none';
    }
  }

  if (loadMoreBtn) {
    loadMoreBtn.classList.remove('is-loading');
  }

  if (!append && data.available_filters) {
    applyAvailableFilters(data.available_filters);
  }

  if (!append) {
    updateEmptyState(typeof data.total !== 'undefined' ? data.total : null);
  }
}

function hasActiveQuery() {
  return searchQuery !== '' || getTotalCount() > 0;
}

function updateEmptyState(total) {
  const emptyState = document.querySelector('.filters-results-empty');
  const grid = document.querySelector('.filters-results-grid');
  const messageEl = emptyState ? emptyState.querySelector('.filters-results-empty-message') : null;
  const shouldShow = total === 0 && hasActiveQuery();

  if (emptyState) {
    emptyState.style.display = shouldShow ? '' : 'none';

    if (messageEl) {
      messageEl.textContent = searchQuery
        ? 'No recipes found for "' + searchQuery + '"'
        : 'No recipes found';
    }
  }

  if (grid) {
    grid.style.display = shouldShow ? 'none' : '';
  }
}

function applyAvailableFilters(availableFilters) {
  if (!availableFilters) return;

  document.querySelectorAll('.filters-courses-list[data-taxonomy]').forEach(function (list) {
    const taxonomy = list.getAttribute('data-taxonomy');
    const available = availableFilters[taxonomy] || [];

    list.querySelectorAll('.filters-courses-list-item').forEach(function (item) {
      const value = item.getAttribute('data-value');
      const isSelected = item.classList.contains('selected');
      const isAvailable = available.indexOf(value) !== -1;
      const isDisabled = !isAvailable && !isSelected;

      item.classList.toggle('is-disabled', isDisabled);
      item.setAttribute('aria-disabled', isDisabled ? 'true' : 'false');
    });
  });

  document.querySelectorAll('.drawer-item[data-taxonomy]').forEach(function (drawerItem) {
    const taxonomy = drawerItem.getAttribute('data-taxonomy');
    const available = availableFilters[taxonomy] || [];

    drawerItem.querySelectorAll('.drawer-content-item').forEach(function (contentItem) {
      const value = contentItem.getAttribute('data-value');
      const checkbox = contentItem.querySelector('input[type="checkbox"]');
      const isSelected = checkbox && checkbox.checked;
      const isAvailable = available.indexOf(value) !== -1;
      const isDisabled = !isAvailable && !isSelected;

      contentItem.classList.toggle('is-disabled', isDisabled);

      if (checkbox) {
        checkbox.disabled = isDisabled;
      }
    });

    const contentItems = drawerItem.querySelectorAll('.drawer-content-item');
    const headerButton = drawerItem.querySelector('.drawer-header');
    const allDisabled = contentItems.length > 0 && Array.from(contentItems).every(function (contentItem) {
      return contentItem.classList.contains('is-disabled');
    });

    drawerItem.classList.toggle('is-disabled', allDisabled);

    if (headerButton) {
      headerButton.disabled = allDisabled;
      headerButton.setAttribute('aria-disabled', allDisabled ? 'true' : 'false');
    }

    if (allDisabled) {
      drawerItem.classList.remove('open');
    }
  });
}

function fetchRecipes(page, append) {
  const url = buildRecipesApiUrl(page);

  return fetch(url.toString())
    .then(function (response) {
      return response.json();
    })
    .then(function (data) {
      updateResultsUI(data, append);
      return data;
    })
    .catch(function (error) {
      console.error('Recipes filter error:', error);
      const loadMoreBtn = document.querySelector('.filters-results-load-more .load-more-button');
      if (loadMoreBtn) {
        loadMoreBtn.classList.remove('is-loading');
      }
    });
}

function fetchWithDelay(options) {
  const shouldScroll = options && options.scroll === true;

  clearTimeout(fetchTimer);
  fetchTimer = setTimeout(function () {
    currentResultsPage = 1;
    fetchRecipes(1, false).finally(function () {
      if (shouldScroll) {
        scrollToResultsSection();
      }
    });
  }, 300);
}

function scrollToResultsSection() {
  const resultsSection = document.querySelector('.filters-results');

  if (!resultsSection) return;

  const headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 0;
  const top = resultsSection.getBoundingClientRect().top + window.scrollY - headerHeight - 24;

  window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
}

function getUrlParams() {
  const params = new URLSearchParams(window.location.search);
  const result = {};
  params.forEach(function (value, key) {
    result[key] = value.split(',').filter(Boolean);
  });
  return result;
}

function pushUrlParams() {
  const params = new URLSearchParams();
  if (searchQuery) params.set('search', searchQuery);
  Object.keys(selectedFilters).forEach(function (taxonomy) {
    const values = selectedFilters[taxonomy];
    if (values && values.length > 0) {
      params.set(taxonomy, values.join(','));
    }
  });
  const qs = params.toString();
  const url = window.location.pathname + (qs ? '?' + qs : '');
  window.history.replaceState(null, '', url);
}

function getTotalCount() {
  let count = 0;
  Object.keys(selectedFilters).forEach(function (key) {
    count += selectedFilters[key].length;
  });
  return count;
}

function clearAllFilters() {
  selectedFilters = {};
  searchQuery = '';
  var clearFormEl = document.getElementById('filters-search-form');
  var clearInputEl = clearFormEl ? clearFormEl.querySelector('#search-input') : null;
  if (clearInputEl) clearInputEl.value = '';

  document.querySelectorAll('.filters-courses-list-item.selected').forEach(function (item) {
    item.classList.remove('selected');
  });

  document.querySelectorAll('.filters-courses-list-item.is-disabled').forEach(function (item) {
    item.classList.remove('is-disabled');
    item.setAttribute('aria-disabled', 'false');
  });

  document.querySelectorAll('.drawer-content-item input[type="checkbox"]:checked').forEach(function (checkbox) {
    checkbox.checked = false;
  });

  document.querySelectorAll('.drawer-content-item input[type="checkbox"]:disabled').forEach(function (checkbox) {
    checkbox.disabled = false;
  });

  document.querySelectorAll('.drawer-content-item.is-disabled').forEach(function (contentItem) {
    contentItem.classList.remove('is-disabled');
  });

  document.querySelectorAll('.drawer-item.is-disabled').forEach(function (drawerItem) {
    drawerItem.classList.remove('is-disabled');
    var headerButton = drawerItem.querySelector('.drawer-header');
    if (headerButton) {
      headerButton.disabled = false;
      headerButton.setAttribute('aria-disabled', 'false');
    }
  });

  document.querySelectorAll('.drawer-header .item-counter').forEach(function (counter) {
    counter.textContent = '';
  });

  document.querySelectorAll('.drawer-controls-number-label').forEach(function (label) {
    label.textContent = '';
    label.classList.add('is-hidden');
  });

  var clearButton = document.querySelector('.drawer-clear-button');
  if (clearButton) {
    clearButton.parentNode.classList.remove('show-clear-button');
  }

  pushUrlParams();
  fetchWithDelay();
}

function updateSelectedFilter(taxonomy, value, isActive) {
  if (!taxonomy) return;
  if (!selectedFilters[taxonomy]) selectedFilters[taxonomy] = [];

  const arr = selectedFilters[taxonomy];
  const idx = arr.indexOf(value);

  if (isActive && idx === -1) {
    arr.push(value);
  } else if (!isActive && idx !== -1) {
    arr.splice(idx, 1);
  }

  if (arr.length === 0) delete selectedFilters[taxonomy];

  const total = getTotalCount();
  const clearButton = document.querySelector('.drawer-clear-button');

  document.querySelectorAll('.drawer-controls-number-label').forEach(function (label) {
    if (total > 0) {
      label.textContent = total;
      label.classList.remove('is-hidden');
    } else {
      label.textContent = '';
      label.classList.add('is-hidden');
    }
  });

  if (clearButton) {
    if (total > 0) {
      clearButton.parentNode.classList.add('show-clear-button');
    } else {
      clearButton.parentNode.classList.remove('show-clear-button');
    }
  }

  pushUrlParams();
  fetchWithDelay();
}

// --- Lettura URL → applicazione stato alla UI ---
function applyUrlToUI() {
  const params = getUrlParams();

  const urlSearch = new URLSearchParams(window.location.search).get('search');
  if (urlSearch) {
    searchQuery = urlSearch;
    var searchFormEl = document.getElementById('filters-search-form');
    var searchInputEl = searchFormEl ? searchFormEl.querySelector('#search-input') : null;
    if (searchInputEl) searchInputEl.value = urlSearch;
  }
  delete params.search;

  Object.keys(params).forEach(function (taxonomy) {
    const values = params[taxonomy];

    // courses (card visive)
    document.querySelectorAll('.filters-courses-list[data-taxonomy="' + taxonomy + '"] .filters-courses-list-item').forEach(function (item) {
      if (values.indexOf(item.getAttribute('data-value')) !== -1) {
        item.classList.add('selected');
      }
    });

    // drawer checkboxes
    document.querySelectorAll('.drawer-item[data-taxonomy="' + taxonomy + '"] .drawer-content-item').forEach(function (contentItem) {
      var val = contentItem.getAttribute('data-value');
      if (values.indexOf(val) !== -1) {
        var cb = contentItem.querySelector('input[type="checkbox"]');
        if (cb) cb.checked = true;
      }
    });
  });

  selectedFilters = params;

  // aggiorna contatori drawer
  document.querySelectorAll('.drawer-item[data-taxonomy]').forEach(function (drawerItem) {
    var taxonomy = drawerItem.getAttribute('data-taxonomy');
    var count = selectedFilters[taxonomy] ? selectedFilters[taxonomy].length : 0;
    var counter = drawerItem.querySelector('.item-counter');
    if (counter) counter.textContent = count > 0 ? '(' + count + ')' : '';
  });

  var total = getTotalCount();
  var clearButton = document.querySelector('.drawer-clear-button');

  document.querySelectorAll('.drawer-controls-number-label').forEach(function (label) {
    if (total > 0) {
      label.textContent = total;
      label.classList.remove('is-hidden');
    } else {
      label.textContent = '';
      label.classList.add('is-hidden');
    }
  });

  if (clearButton) {
    if (total > 0) {
      clearButton.parentNode.classList.add('show-clear-button');
    } else {
      clearButton.parentNode.classList.remove('show-clear-button');
    }
  }
}

// --- Init: applica stato URL alla UI ---
applyUrlToUI();
fetchWithDelay({ scroll: getTotalCount() > 0 || searchQuery !== '' });

// --- Search form ---
var searchForm = document.getElementById('filters-search-form');

if (searchForm) {
  searchForm.addEventListener('submit', function (e) {
    e.preventDefault();
    var input = searchForm.querySelector('#search-input');
    searchQuery = input ? input.value.trim() : '';
    pushUrlParams();
    fetchWithDelay({ scroll: true });
  });
}

// --- Courses list click ---
const filtersRecipe = document.querySelectorAll('.filters-courses-list[data-taxonomy]');
if (filtersRecipe.length > 0) {
  filtersRecipe.forEach(function (filters) {
    const taxonomy = filters.getAttribute('data-taxonomy');
    const filtersCoursesList = filters.querySelectorAll('.filters-courses-list-item');
    filtersCoursesList.forEach(function (item) {
      item.addEventListener('click', function () {
        if (item.classList.contains('is-disabled') && !item.classList.contains('selected')) {
          return;
        }

        item.classList.toggle('selected');
        const value = item.getAttribute('data-value');
        if (value) updateSelectedFilter(taxonomy, value, item.classList.contains('selected'));
      });
    });
  });
}

// --- Drawer checkboxes ---
const drawerContentItems = document.querySelectorAll('.drawer-item[data-taxonomy] .drawer-content-item');
if (drawerContentItems.length > 0) {
  drawerContentItems.forEach(function (contentItem) {
    const checkbox = contentItem.querySelector('input[type="checkbox"]');
    if (!checkbox) return;

    const drawerItem = contentItem.closest('.drawer-item');
    const taxonomy = drawerItem ? drawerItem.getAttribute('data-taxonomy') : null;
    const value = contentItem.getAttribute('data-value');

    checkbox.addEventListener('change', function () {
      if (checkbox.disabled) {
        checkbox.checked = false;
        return;
      }

      if (value && taxonomy) updateSelectedFilter(taxonomy, value, checkbox.checked);

      if (drawerItem) {
        const checkedCount = drawerItem.querySelectorAll('.drawer-content-item input[type="checkbox"]:checked').length;
        const counter = drawerItem.querySelector('.item-counter');
        if (counter) counter.textContent = checkedCount > 0 ? '(' + checkedCount + ')' : '';
      }
    });
  });
}

// --- Load more risultati filtri ---
const filtersLoadMoreWrap = document.querySelector('.filters-results-load-more');

if (filtersLoadMoreWrap) {
  const filtersLoadMoreBtn = filtersLoadMoreWrap.querySelector('.load-more-button');

  if (filtersLoadMoreBtn) {
    filtersLoadMoreBtn.addEventListener('click', function () {
      if (filtersLoadMoreBtn.classList.contains('is-loading')) return;

      filtersLoadMoreBtn.classList.add('is-loading');
      fetchRecipes(currentResultsPage + 1, true);
    });
  }
}

// --- Swiper recipe courses ---
const swiperRecipeCourses = document.querySelectorAll('.swiper-recipe-courses');
if (swiperRecipeCourses.length > 0) {
  swiperRecipeCourses.forEach(function (swiper) {
    const swiperInstance = new Swiper(swiper, {
      slidesPerView: 7,
      spaceBetween: 32,
      pagination: {
        el: swiper.querySelector('.carousel-pagination-filters'),
        clickable: true,
      },
      breakpoints: {
        0: {
          slidesPerView: 3.25,
          spaceBetween: 16,
        },
        768: {
          slidesPerView: 5.25,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 7,
          spaceBetween: 32,
        },
      },
    });
  });
}

// --- Drawer-item toggle (accordion mobile / dropdown desktop) ---
const drawerItems = document.querySelectorAll('.drawer-item');
if (drawerItems.length > 0) {
  drawerItems.forEach(function (item) {
    const header = item.querySelector('.drawer-header');
    if (!header) return;
    header.addEventListener('click', function () {
      if (item.classList.contains('is-disabled')) {
        return;
      }

      drawerItems.forEach(function (other) {
        if (other !== item) other.classList.remove('open');
      });
      item.classList.toggle('open');
    });
  });

  document.addEventListener('click', function (e) {
    if (window.innerWidth >= 1024 && !e.target.closest('.drawer-item')) {
      drawerItems.forEach(function (item) {
        item.classList.remove('open');
      });
    }
  });
}

// --- Filters drawer toggle ---
const filterDrawerControls = document.querySelectorAll('.drawer-controls');
if (filterDrawerControls.length > 0) {
  filterDrawerControls.forEach(function (controls) {
    const toggleOpenButton = controls.querySelector('.drawer-toggle-button');
    toggleOpenButton.addEventListener('click', function () {
      const mask = controls.parentNode.querySelector('.drawer-filters-mask');
      toggleOpenButton.classList.toggle('is-drawer-open');
      mask.classList.toggle('open');
      if (mask.classList.contains('open')) {
        setTimeout(() => { mask.style.overflow = 'visible' }, 300);
      } else {
        mask.style.overflow = 'hidden';
      }
    });

    const clearButton = controls.querySelector('.drawer-clear-button');
    if (clearButton) {
      clearButton.addEventListener('click', clearAllFilters);
    }
  });
}

const showAllRecipesButton = document.querySelector('.filters-results-empty-button');
if (showAllRecipesButton) {
  showAllRecipesButton.addEventListener('click', clearAllFilters);
}
